import { Col } from 'react-bootstrap';

function Nike(props) {
    return(
        <Col md={4}>
            <img alt="item2" src={props.nike1.imgUrl} width="80%" />
            <h5>{props.nike1.title}</h5>
            <p>{props.nike1.content}</p>
            <p>{props.nike1.price}</p>
        </Col>
    )
}

export default Nike;